// Inline SVG rather than a file in public/: it costs zero network requests,
// inherits the surrounding colour, and needs no build configuration. No
// placeholder URL is ever persisted or returned by the API — the client
// derives which mark to show from the account's `sex` value.
//
// Presentation is deliberately neutral and utilitarian: the three marks differ
// only in shoulder line, and none carries a value judgement.
export default function NeutralAvatar({ className = "", title = "No profile photo", ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="32" className="fill-slate-100" />
      <circle cx="32" cy="25" r="10" className="fill-slate-400" />
      <path d="M12 57c0-10.5 9-18 20-18s20 7.5 20 18v7H12v-7Z" className="fill-slate-400" />
    </svg>
  );
}
